import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';
import uiTabs  from 'angular-ui-bootstrap/src/tabs';
import {pregled} from '../pregled/pregled.js';
import {nalaz} from '../nalaz/nalaz.js';

import {PacijentComponent} from './pacijent.component.js';
import {DetaljiPacijentaComponent} from './detalji.pacijenta.component.js';
import {GridComponent} from './grid/grid.js';
import {DetailComponent} from './detail/detail.js';
import PacijentFormComponent from './form/form.js';
import {NapomenaEditComponent} from './form/form.js';


const pacijent = angular.module('pacijent', [uiModal, uiTabs, pregled.name, nalaz.name]);

pacijent.component('pacijent', PacijentComponent);
pacijent.component('detaljiPacijenta', DetaljiPacijentaComponent);

pacijent.component('pacijentForm', PacijentFormComponent);
pacijent.component('pacijentNapomenaForm', NapomenaEditComponent);
pacijent.component('pacijentGrid', GridComponent);
pacijent.component('pacijentDetail', DetailComponent);

export {pacijent};



// WEBPACK FOOTER //
// ./app/components/pacijent/pacijent.js